/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmbeddingResponsePage } from '../../models/embedding-response-page';

export interface ListEmbeddings$Params {
  segmentId?: Array<string>;
  articleId?: Array<string>;
  model?: string;
  from?: string;
  to?: string;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'model' | '-model' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt' | 'articleId' | '-articleId'>;
}

export function listEmbeddings(http: HttpClient, rootUrl: string, params?: ListEmbeddings$Params, context?: HttpContext): Observable<StrictHttpResponse<EmbeddingResponsePage>> {
  const rb = new RequestBuilder(rootUrl, listEmbeddings.PATH, 'get');
  if (params) {
    rb.query('segmentId', params.segmentId, {"style":"form"});
    rb.query('articleId', params.articleId, {"style":"form"});
    rb.query('model', params.model, {"style":"form"});
    rb.query('from', params.from, {"style":"form"});
    rb.query('to', params.to, {"style":"form"});
    rb.query('offset', params.offset, {"style":"form"});
    rb.query('limit', params.limit, {"style":"form"});
    rb.query('sorting', params.sorting, {"style":"form"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmbeddingResponsePage>;
    })
  );
}

listEmbeddings.PATH = '/v0/embeddings';
